function yaC(){

    window.onload = function () {
        if(typeof window.Ya !== 'undefined'){
            getYaId();
        } else {
            setTimeout(function (){
                if(typeof window.Ya !== 'undefined'){
                    getYaId();
                }
            }, 1000)
        }
    }

    function getYaId(){
        if (window.Ya.Metrika2) {
            window.yaC = window.Ya.Metrika2.counters()[0].id;
        } else {
            window.yaC = window.Ya.Metrika.counters()[0].id;
        }
    }
}

export default yaC;